module.exports = __webpack_public_path__ + "img/logo.38c4d7a0.png";